import { Worksheet } from './budgetCalculatorModel'
import * as SalesModel from './salesModel'
import * as LaborModel from './laborModel'
import * as MaterialsModel from './materialsModel'
import * as SubcontractorModel from './subcontractorModel'
import * as OverheadModel from './overheadModel'
import * as EquipmentModel from './equipmentModel'
import * as BudgetModel from './budgetModel'

export const enforceInvariants = (worksheet: Worksheet): Worksheet => {
  return {
    ...worksheet,
    data: {
      ...worksheet.data,
      salesGoals: SalesModel.enforceInvariants(worksheet.data.salesGoals),
      employees: LaborModel.enforceInvariants(worksheet.data.employees),
      materials: MaterialsModel.enforceInvariants(worksheet.data.materials),
      subcontractors: SubcontractorModel.enforceInvariants(worksheet.data.subcontractors),
      overheadGroups: OverheadModel.enforceInvariants(worksheet.data.overheadGroups),
      equipmentList: EquipmentModel.enforceInvariants(worksheet.data.equipmentList),
      profit: BudgetModel.enforceInvariants(worksheet.data.profit)
    }
  }
}